import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  snapDefaultBank,
  unSnapDefaultBank,
} from "store/bailiff/default/bank/default_bank.action";
import {
  snapDefaultWallet,
  unSnapDefaultWallet,
} from "store/bailiff/default/wallet/default_wallet.action";
import {
  snapSettingWithdraw,
  unSnapSettingWithdraw,
} from "store/bailiff/default/withdraw/setting_withdraw.action";

import { getFinanceResellerByDate } from "store/bailiff/finance/reseller/finance_reseller.action";
import { financeResellerDatesSelector } from "store/bailiff/finance/reseller/finance_reseller.selector";
import {
  fetchBanksList,
  getPaymentWithdrawByDates,
  snapLastWithdraw,
  unSnapLastWithdraw,
} from "store/bailiff/payment/withdraw/payment_withdraw.action";
//
//component
//redux
//selector
//actions
export const TriggerInit = () => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const dates = useSelector(financeResellerDatesSelector);

  // -------------------------- USE EFFECT ---------------------

  // get finance
  useEffect(() => {
    if (dates && dates?.length > 0) {
      const from = dates?.[0];
      const to = dates?.[1];
      dispatch(getFinanceResellerByDate({ from, to }));
    }
  }, [dates, dispatch]);

  //get withdraw
  useEffect(() => {
    if (dates && dates?.length > 0) {
      const from = dates?.[0];
      const to = dates?.[1];
      dispatch(getPaymentWithdrawByDates({ from, to }));
    }
  }, [dates, dispatch]);

  // snap my banks account
  useEffect(() => {
    dispatch(snapDefaultBank());
    return () => dispatch(unSnapDefaultBank());
  }, [dispatch]);

  // snap setting
  useEffect(() => {
    dispatch(snapSettingWithdraw());
    return () => dispatch(unSnapSettingWithdraw());
  }, [dispatch]);

  // snap wallet
  useEffect(() => {
    dispatch(snapDefaultWallet());
    return () => dispatch(unSnapDefaultWallet());
  }, [dispatch]);

  // snap last withdraw
  useEffect(() => {
    dispatch(snapLastWithdraw());
    return () => dispatch(unSnapLastWithdraw());
  }, [dispatch]);

  // GET BANK LISTS
  useEffect(() => {
    dispatch(fetchBanksList());
  }, [dispatch]);

  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerInit;
